export default class Util {
  static getRandomInt(max) {
    return Math.floor(Math.random() * max)
  }

  static dedupe(ary, key) {
    const set = {}
    ary.forEach(x => set[x[key]] = x)
    return Object.values(set)
  }

  static chunk(arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    )
  }

  static takeChunk(arr, size) {
    return [arr.slice(0, size), arr.slice(size)]
  }

  static alternatingChunk(arr, size, alternatingSize) {
    const output = []
    let flag = true

    while(arr.length > 0) {
      const limit = flag ? size : alternatingSize
      const [bucket, newArr] = this.takeChunk(arr, limit)
      output.push(bucket)
      flag = !flag
      arr = newArr
    }

    return output
  }

  static formatFileName(str) {
    if(!str) return ''

    return str.trim().replace(/\s+/g, '-').replace(/@+/g, '')
  }
}
